<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="deviceName" label="设备名称">
            <el-input v-model="formData.deviceName" placeholder="请输入设备名称"></el-input>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="location" label="安装位置">
            <el-input v-model="formData.location" placeholder="请输入安装位置"></el-input>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="status" label="当前状态">
              <el-select v-model="formData.status" clearable filterable placeholder="请选择当前状态">
            <el-option v-for="(item, index) of statusArr" :value="item.value" :label="item.label"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deviceCode" label="设备代码">
            <el-input v-model="formData.deviceCode" placeholder="请输入设备代码"></el-input>

          </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="manager" label="管理人">
              <el-select v-model="formData.manager" clearable filterable placeholder="请选择检查结果">
            <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
              :key="index"></el-option>
          </el-select>
          </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'specialEquipmentAdd',

  data () {
    return {
      formData: {
        deviceName: '',
        location: '',
        deviceCode: '',
        status: '',
        manager: ''
      },

      rules: {

        deviceName: [
          {
            required: true,
            message: '请输入设备名称',
            trigger: ['blur', 'change']
          }
        ],
        location: [
          {
            required: true,
            message: '请输入设备位置',
            trigger: ['blur', 'change']
          }
        ],
        deviceCode: [
          {
            required: true,
            message: '请输入设备代码',
            trigger: ['blur', 'change']
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: ['blur', 'change']
          }
        ],
        manager: [
          {
            required: true,
            message: '请选择管理人',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      userList: [],
      statusArr: [
        {
          label: '闲置',
          value: '1'
        },
        {
          label: '运行',
          value: '2'
        },
        {
          label: '维护',
          value: '3'
        }

      ]

    }
  },
  created () {
    this.loadUser()
    if (this.deviceId) {
      this.loadData()
    }
  },
  computed: {
    deviceId () {
      return this.$route.query.deviceId
    }

  },
  methods: {
    loadUser() {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '1'
      }).then(res => {
        this.userList = res || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.specialEquipment.selectPaSpecialEquipmentByDeviceId, {
          params: { deviceId: this.deviceId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.specialEquipment.insertPaSpecialEquipment
          if (this.deviceId) {
            url = this.$apis.specialEquipment.updatePaSpecialEquipment
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

</style>
